import { useState, useRef, useEffect } from "react";
import CoordinatorHeader from '../../components/Header/CoordinatorHeader'
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar'
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import SideBar from '../../components/SideBar/SideBar'
import fulleventStyle from './FullEventPage.module.css'
import Authorimage from '../../../assets/images/9780823454143.jpg'
import { IoLinkOutline } from "react-icons/io5";
import { Checkbox } from 'rsuite';
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { DateRangePicker } from 'rsuite';
import { FiPlusCircle } from "react-icons/fi";


export default function FullEventPage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open
    const [eventData, setEventData] = useState([]);  // For storing event data
    const [showAllBooks, setShowAllBooks] = useState(false);
    const { id } = useParams();
    const cordinatorID = localStorage.getItem('cordinator_id');
    const cordinatorFName = localStorage.getItem('coordinatorFName');
    const cordinatorLName = localStorage.getItem('coordinatorLName');
    const cordinatorPosition = localStorage.getItem('coordinatorPosition');
    const cordinatorPic = localStorage.getItem('coordinatorPic');
    const [editableEvent, setEditableEvent] = useState(null);
    const [newBookIsbn, setNewBookIsbn] = useState({});
    // API call to get event data and authors data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const eventResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?id=${id}`);

                if (eventResponse.status !== 200) {
                    throw new Error('Failed to fetch events');
                }

                const data = await eventResponse.data;

                // console.log('data', data);


                if (data.success && Array.isArray(data.events)) {
                    // console.log('ee', data.events);
                    const updatedEvents = data.events.map(event => {
                        let books = [];
                        try {
                            if (event.book_data && typeof event.book_data === 'string') {
                                books = JSON.parse(event.book_data);
                            } else if (Array.isArray(event.book_data)) {
                                books = event.book_data;
                            }
                        } catch (error) {
                            console.error("Error parsing book_data:", error);
                        }

                        return { ...event, books };
                    });

                    setEventData(updatedEvents);  // Set the updated event data state
                    setEditableEvent(updatedEvents[0]);
                    // console.log(eventData,'eeeeeeeeee');
                } else {
                    throw new Error('Invalid events data');
                }
            } catch (error) {
                console.error("Error fetching event or author data:", error);
            }
        };

        fetchData();
    }, [id]);  // Dependency on `id` to fetch the data when `id` changes


    const formatDateMMDDYYYY = (dateString) => {
        // console.log("dateString", dateString)
        if (!dateString || dateString === "0000-00-00 00:00:00") return "000";

        const date = new Date(dateString.replace(" ", "T"));

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };



    // Log eventData after it's updated
    // useEffect(() => {
    //     if (eventData.length > 0) {
    //         console.log("Event data is updated:", eventData[0].event_name);
    //     }
    // }, [eventData]);

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    const [open, setOpen] = useState(false);
    const boxRef = useRef();

    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const formatToAMPM = (time) => {
        if (!time) return '';

        const [hour, minute] = time.split(':');
        const date = new Date();
        date.setHours(hour, minute);

        return date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        }).toUpperCase();
        ;
    };

    const handleInputChange = (field, value) => {
        setEditableEvent((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleDateChange = (range) => {
        if (!range) return;

        const [start, end] = range;

        setEditableEvent({
            ...editableEvent,
            event_start_date: start.toISOString().split("T")[0],
            event_end_date: end.toISOString().split("T")[0],
        });
    };

    const handleStartTimeChange = (e) => {
        setEditableEvent({
            ...editableEvent,
            event_start_time: e.target.value,
        });
    };

    const handleEndTimeChange = (e) => {
        setEditableEvent({
            ...editableEvent,
            event_end_time: e.target.value,
        });
    };

    const isDraft = editableEvent?.status === "draft";

    const timeOptions = [];
    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 15) {  // 15 min interval
            const hour = h.toString().padStart(2, "0");
            const minute = m.toString().padStart(2, "0");
            timeOptions.push(`${hour}:${minute}`);
        }
    }

    const handleSaveEvent = async () => {
        if (!editableEvent) return;
        // Build the bookDataArray from current eventData
        const bookDataArray = eventData.flatMap((event) =>
            event.books.map((book) => ({
                author_id: book.authorData ? Object.values(book.authorData)[0] : null,
                author_name: book.authorName,
                authorBookDataAdded: book.authorBookDataAdded.map((a) => ({
                    books: a.books.map((b) => ({
                        title: b.title,
                        price: b.price,
                        isbn: b.isbn
                    }))
                }))
            }))
        );

        const postData = {
            event_id: editableEvent.tbl_event_id,
            eventName: editableEvent.event_name,
            formattedStartDate: editableEvent.event_start_date,
            formattedEndDate: editableEvent.event_end_date,
            eventDetail: editableEvent.event_detail,
            eventLocation: editableEvent.event_location,
            eventNotes: editableEvent.event_notes,
            event_start_time: editableEvent.event_start_time,
            event_end_time: editableEvent.event_end_time,
            event_status: editableEvent.event_status,
            cordinator_id: cordinatorID,
            bookDataArray // include updated books here
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}authormeetapi/save_event_data.php`,
                postData,
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.data.status === "success") {
                Swal.fire({
                    title: "Event Updated!",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    navigate("/coordinator-dashboard");
                });
            }
        } catch (error) {
            console.error(error);
            alert("Failed to update event.");
        }
    };

    const handleRemoveBook = (bookIndex, flatBookIndex) => {
        const updatedEventData = [...eventData];

        // Get the specific book object
        const authorBookDataAdded = updatedEventData[0].books[bookIndex].authorBookDataAdded;

        let counter = 0;

        const newAuthorBookDataAdded = authorBookDataAdded.map((a) => {
            const newBooks = a.books.filter((b) => {
                if (counter === flatBookIndex) {
                    counter++;
                    return false; // remove this book
                } else {
                    counter++;
                    return true; // keep the rest
                }
            });
            return { ...a, books: newBooks };
        });

        updatedEventData[0].books[bookIndex].authorBookDataAdded = newAuthorBookDataAdded;
        setEventData(updatedEventData);
    };

    const handleAddBook = (bookIndex) => {
        const isbn = newBookIsbn[bookIndex]?.trim();
        if (!isbn) return alert("Please enter ISBN");

        const updatedEventData = [...eventData];

        // Get the specific book
        const book = updatedEventData[0].books[bookIndex];

        // Initialize authorBookDataAdded if undefined
        if (!book.authorBookDataAdded) {
            book.authorBookDataAdded = [{ books: [] }];
        }

        // Use the first sub-array (or create it)
        const authorBooksArray = book.authorBookDataAdded[0].books;

        // Check if ISBN already exists
        if (authorBooksArray.some((b) => b.isbn === isbn)) {
            return alert("Book already added");
        }

        // Add a placeholder book (title/price will come from API)
        authorBooksArray.push({
            isbn: isbn,
            title: "", // will be fetched from API
            price: "",
        });

        setEventData(updatedEventData);

        // Clear input
        setNewBookIsbn((prev) => ({ ...prev, [bookIndex]: "" }));

        // Optional: fetch book details from API and update title/price
        fetchBookDetails(bookIndex, isbn);
    };

    const fetchBookDetails = async (bookIndex, isbn) => {
        const authorId = eventData[0].books[bookIndex].authorData
            ? Object.values(eventData[0].books[bookIndex].authorData)[0]
            : null;

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_event.php`,
                { params: { isbn, author_id: authorId } }
            );

            if (res.data.success && res.data.users.length > 0) {
                const bookDetails = res.data.users[0];
                const updatedEventData = [...eventData];

                updatedEventData[0].books[bookIndex].authorBookDataAdded[0].books = updatedEventData[0].books[
                    bookIndex
                ].authorBookDataAdded[0].books.map((b) =>
                    b.isbn === isbn
                        ? { ...b, title: bookDetails.title, price: bookDetails.price }
                        : b
                );

                setEventData(updatedEventData);
            } else {
                alert(res.data.message || "Book not found for this author");
                // remove placeholder
                const updatedEventData = [...eventData];
                updatedEventData[0].books[bookIndex].authorBookDataAdded[0].books =
                    updatedEventData[0].books[bookIndex].authorBookDataAdded[0].books.filter((b) => b.isbn !== isbn);
                setEventData(updatedEventData);
            }
        } catch (err) {
            console.error(err);
            alert("Failed to fetch book details");
        }
    };

    // const addAccordion = () => {
    //     // setAccordionData(prev => {
    //     //     const newAccordion = {
    //     //         authorName: '',
    //     //         authorISBN: '',
    //     //         authorEmail: '',
    //     //         authorData: null,
    //     //         authorBookData: [],
    //     //         loading: false,
    //     //         error: null,
    //     //         error1: null,
    //     //         authorDataAdded: null,
    //     //         authorBookDataAdded: [],
    //     //         showInviteForm: false,
    //     //     };

    //     //     const newData = [...prev, newAccordion];
    //     //     setOpenIndex(newData.length - 1);

    //     //     return newData;
    //     // });

    //     Swal.fire({
    //         title: "Enter Author Name",
    //         input: "text",
    //         inputPlaceholder: "Type your name...",
    //         showCancelButton: true,
    //         confirmButtonText: "Confirm",
    //         cancelButtonText: "Cancel",
    //         inputValidator: (value) => {
    //             if (!value) {
    //                 return "Name is required!";
    //             }
    //         }
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             const userName = result.value;

    //             // 👉 use the name here
    //             console.log(userName);

    //             navigate("/coordinator-dashboard");
    //         }
    //     });
    // };

    // console.log("eventData", eventData);

    // const addAccordion = () => {
    //     Swal.fire({
    //         title: "Enter Author Name",
    //         input: "text",
    //         inputPlaceholder: "Type the author name...",
    //         showCancelButton: true,
    //         confirmButtonText: "Confirm",
    //         cancelButtonText: "Cancel",
    //         inputValidator: (value) => {
    //             if (!value) {
    //                 return "Name is required!";
    //             }
    //         }
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             const authorName = result.value;

    //             // Add a new author to eventData
    //             setEventData((prev) => {
    //                 const newAuthor = {
    //                     authorName: authorName,
    //                     authorISBN: "",
    //                     authorEmail: "",
    //                     authorData: null,
    //                     authorBookData: [],
    //                     authorBookDataAdded: [{ books: [] }],
    //                     loading: false,
    //                     error: null,
    //                     error1: null,
    //                     showInviteForm: false,
    //                 };

    //                 const updatedData = [...prev];

    //                 // Assuming eventData[0] exists and stores books
    //                 if (!updatedData[0].books) {
    //                     updatedData[0].books = [];
    //                 }

    //                 updatedData[0].books.push(newAuthor);

    //                 // Open the newly added accordion
    //                 setOpenIndex(updatedData[0].books.length - 1);

    //                 return updatedData;
    //             });
    //         }
    //     });
    // };


    //     const addAccordion = () => {
    //     // Example list of authors
    //     const authorOptions = [
    //         "J.K. Rowling",
    //         "George R.R. Martin",
    //         "Agatha Christie",
    //         "Stephen King",
    //         "Mark Twain"
    //     ];

    //     // Create HTML input with datalist
    //     const inputHtml = `
    //         <input list="authors" id="swal-input" class="swal2-input" placeholder="Type author name...">
    //         <datalist id="authors">
    //             ${authorOptions.map(name => `<option value="${name}">`).join("")}
    //         </datalist>
    //     `;

    //     Swal.fire({
    //         title: "Select Author",
    //         html: inputHtml,
    //         showCancelButton: true,
    //         confirmButtonText: "Confirm",
    //         cancelButtonText: "Cancel",
    //         preConfirm: () => {
    //             const input = Swal.getPopup().querySelector('#swal-input').value;
    //             if (!input) {
    //                 Swal.showValidationMessage("Author name is required!");
    //             }
    //             return input;
    //         }
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             const authorName = result.value;

    //             setEventData(prev => {
    //                 const newAuthor = {
    //                     authorName: authorName,
    //                     authorISBN: "",
    //                     authorEmail: "",
    //                     authorData: null,
    //                     authorBookData: [],
    //                     authorBookDataAdded: [{ books: [] }],
    //                     loading: false,
    //                     error: null,
    //                     error1: null,
    //                     showInviteForm: false,
    //                 };

    //                 const updatedData = [...prev];

    //                 if (!updatedData[0].books) updatedData[0].books = [];

    //                 updatedData[0].books.push(newAuthor);

    //                 setOpenIndex(updatedData[0].books.length - 1);

    //                 return updatedData;
    //             });
    //         }
    //     });
    // };

    const addAccordion = () => {
        const authorOptions = [
            "J.K. Rowling",
            "George R.R. Martin",
            "Agatha Christie",
            "Stephen King",
            "Mark Twain"
        ];

        const inputHtml = `
        <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
            <label for="swal-input" style="font-weight: bold; font-size: 16px;">Author Name</label>
            <input list="authors" id="swal-input" class="swal2-input" 
                placeholder="Start typing author's name..." 
                style="padding: 10px; border-radius: 8px; border: 1px solid #ccc; font-size: 14px;">
            <datalist id="authors">
                ${authorOptions.map(name => `<option value="${name}">`).join("")}
            </datalist>
            <small style="color: #666;">Select from the list or type a new author</small>
        </div>
    `;

        Swal.fire({
            title: "Select Author",
            html: inputHtml,
            showCancelButton: true,
            confirmButtonText: "Add Author",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            focusConfirm: false,
            customClass: {
                popup: 'swal2-popup-custom',
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom'
            },
            preConfirm: () => {
                const input = Swal.getPopup().querySelector('#swal-input').value.trim();
                if (!input) {
                    Swal.showValidationMessage("Author name is required!");
                }
                return input;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const authorName = result.value;

                setEventData(prev => {
                    const newAuthor = {
                        authorName: authorName,
                        authorISBN: "",
                        authorEmail: "",
                        authorData: null,
                        authorBookData: [],
                        authorBookDataAdded: [{ books: [] }],
                        loading: false,
                        error: null,
                        error1: null,
                        showInviteForm: false,
                    };

                    const updatedData = [...prev];

                    if (!updatedData[0].books) updatedData[0].books = [];
                    updatedData[0].books.push(newAuthor);
                    setOpenIndex(updatedData[0].books.length - 1);

                    return updatedData;
                });
            }
        });
    };

    const handleDeleteAuthor = (authorIndex) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this author?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/delete_event_author.php`,
                        {
                            event_id: id,
                            authorIndex: authorIndex
                        }
                    );

                    const res = response.data;

                    if (res.status) {
                        // ✅ Update frontend state
                        setEventData((prev) => prev.filter((_, i) => i !== authorIndex));

                        Swal.fire({
                            title: "Deleted!",
                            text: "Author has been deleted.",
                            icon: "success",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    } else {
                        throw new Error(res.message || "Delete failed");
                    }

                } catch (err) {
                    Swal.fire(
                        "Error",
                        err.response?.data?.message || err.message || "Something went wrong",
                        "error"
                    );
                }
            }
        });
    };


    // console.log("editableEvent :" , editableEvent?.JSON.parse(book_data))







    return (
        <>
            <CoordinatorHeader />
            {isMobile ? (
                <div className={fulleventStyle.fulleventmobiltopbar}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-12'>
                                <CoordinatorMobilPageBar />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={fulleventStyle.fulleventDesktopbar}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-12'>
                                <CoordinatorPageBar />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isMobile ? (
                <div className={fulleventStyle.fulleventmobilepage}>

                </div>
            ) : (
                <div className={fulleventStyle.fulleventDesktoppage}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col' style={{ maxWidth: '275px' }}>
                                <SideBar degination={cordinatorPosition} uname={cordinatorFName} ulname={cordinatorLName} userid={cordinatorID} />
                            </div>
                            <div className="col">
                                <div className={`${fulleventStyle.fulleventdetailContent}`}>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className='row'>
                                                <div className="col-lg-6">
                                                    <h4 className={fulleventStyle.fulleventNames}> Event Name </h4>
                                                    {editableEvent?.status === "draft" ? (
                                                        <input
                                                            type="text"
                                                            className={`${fulleventStyle.fulleventInput} form-control`}
                                                            value={editableEvent?.event_name || ""}
                                                            onChange={(e) => handleInputChange("event_name", e.target.value)}
                                                        />
                                                    ) : (
                                                        <p className={`${fulleventStyle.fulleventsubNames} mb-0`}>
                                                            {editableEvent?.event_name}
                                                        </p>
                                                    )}
                                                    {/* <p className={`${fulleventStyle.fulleventsubNames} mb-0`}>{eventData.length > 0 ? eventData[0].event_name : "Loading..."} : {eventData.length > 0 ? eventData[0].books[0].authorName : "Loading..."}</p> */}
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <label className={`${fulleventStyle.fulleventLabel} form-label`}>
                                                        Start and End Date
                                                    </label>

                                                    {isDraft ? (
                                                        <DateRangePicker
                                                            appearance="default"
                                                            placeholder="Start and End Date"
                                                            onChange={handleDateChange}
                                                            style={{ width: "100%" }}
                                                            className={fulleventStyle.fulleventDate}
                                                            format="MM/dd/yyyy"
                                                            value={
                                                                editableEvent?.event_start_date && editableEvent?.event_end_date
                                                                    ? [
                                                                        new Date(editableEvent.event_start_date),
                                                                        new Date(editableEvent.event_end_date),
                                                                    ]
                                                                    : null
                                                            }
                                                        />
                                                    ) : (
                                                        <p className={`${fulleventStyle.fulleventsubNames}`}>
                                                            {editableEvent
                                                                ? `${formatDateMMDDYYYY(editableEvent.event_start_date)} - ${formatDateMMDDYYYY(editableEvent.event_end_date)}`
                                                                : "Loading..."}
                                                        </p>
                                                    )}
                                                </div>
                                                {/*<div className="mb-4">
                                    <h4 className={fulleventStyle.fulleventNames}> Start and End Date </h4>
                                    <p className={`${fulleventStyle.fulleventsubNames} mb-0`}>
                                        {eventData.length > 0
                                        ? `${formatDateMMDDYYYY(eventData[0].event_start_date)} - ${formatDateMMDDYYYY(eventData[0].event_end_date)}`
                                        : "Loading..."}
                                    </p>
                                    </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mb-3'>
                                        <div className="col-md-6">
                                            <label className={`${fulleventStyle.fulleventLabel} form-label`}> Event Details </label>
                                            {/*<input type="text" className={`${fulleventStyle.fulleventInput} form-control`} value={eventData.length > 0 ? eventData[0].event_detail : "Loading..."} placeholder='Grade: K - 5' /> */}
                                            {editableEvent?.status === "draft" ? (
                                                <input
                                                    type="text"
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    value={editableEvent?.event_detail || ""}
                                                    onChange={(e) => handleInputChange("event_detail", e.target.value)}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    value={editableEvent?.event_detail || ""}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <label className={`${fulleventStyle.fulleventLabel} form-label`}> Location </label>
                                            {/*<input type="text" className={`${fulleventStyle.fulleventInput} form-control`} value={eventData.length > 0 ? eventData[0].event_location : "Loading..."}  placeholder='Library' />*/}
                                            {editableEvent?.status === "draft" ? (
                                                <input
                                                    type="text"
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    value={editableEvent?.event_location || ""}
                                                    onChange={(e) => handleInputChange("event_location", e.target.value)}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    value={editableEvent?.event_location || ""}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                        <div className="row">

                                            {/* START TIME */}
                                            <div className="col-lg-6 mb-3">
                                                <label className={`${fulleventStyle.fulleventLabel} form-label`}>
                                                    Start Time
                                                </label>

                                                {isDraft ? (
                                                    <select
                                                        className={`${fulleventStyle.starttimeinput} form-control`}
                                                        value={editableEvent?.event_start_time || timeOptions[0]} // auto-fill first option if missing
                                                        onChange={handleStartTimeChange}
                                                    >
                                                        {timeOptions.map((t) => (
                                                            <option key={t} value={t}>
                                                                {t}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formatToAMPM(editableEvent?.event_start_time)}
                                                        disabled
                                                    />
                                                )}
                                            </div>

                                            {/* END TIME */}
                                            <div className="col-lg-6 mb-3">
                                                <label className={`${fulleventStyle.fulleventLabel} form-label`}>
                                                    End Time
                                                </label>

                                                {isDraft ? (
                                                    <select
                                                        className={`${fulleventStyle.starttimeinput} form-control`}
                                                        value={editableEvent?.event_end_time || timeOptions[0]} // auto-fill first option if missing
                                                        onChange={handleEndTimeChange}
                                                    >
                                                        {timeOptions
                                                            .filter(
                                                                (t) =>
                                                                    !editableEvent?.event_start_time ||
                                                                    t > editableEvent?.event_start_time
                                                            )
                                                            .map((t) => (
                                                                <option key={t} value={t}>
                                                                    {t}
                                                                </option>
                                                            ))}
                                                    </select>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formatToAMPM(editableEvent?.event_end_time)}
                                                        disabled
                                                    />
                                                )}
                                            </div>

                                        </div>
                                        {/*<div className="col-md-3">
                                <label className={`${fulleventStyle.fulleventLabel} form-label`}> Time </label>
                                <input type="text" className={`${fulleventStyle.fulleventInput} form-control`}
                                    value={eventData.length > 0
                                        ? `${formatToAMPM(eventData[0].event_start_time)} - ${formatToAMPM(eventData[0].event_end_time)}`
                                        : ''
                                    } />
                            </div>*/}
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-11">
                                            <label className={`${fulleventStyle.fulleventLabel} form-label`}> Message for Parents </label>
                                            {/*<textarea className={`${fulleventStyle.fulleventInput} form-control`} rows="4" value={eventData.length > 0 ? eventData[0].event_notes : "Loading..."} ></textarea> */}
                                            {editableEvent?.status === "draft" ? (
                                                <textarea
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    rows="4"
                                                    value={editableEvent?.event_notes || ""}
                                                    onChange={(e) => handleInputChange("event_notes", e.target.value)}
                                                />
                                            ) : (
                                                <textarea
                                                    className={`${fulleventStyle.fulleventInput} form-control`}
                                                    rows="4"
                                                    value={editableEvent?.event_notes || ""}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/*<div className='row mb-3'>
                            <div className="col-md-3">
                                <label className={`${fulleventStyle.fulleventLabel} form-label`}> Event Details </label>
                                <input type="text" className={`${fulleventStyle.fulleventInput} form-control`} value={eventData.length > 0 ? eventData[0].event_detail : "Loading..."} placeholder='Grade: K - 5' />
                            </div>
                            <div className="col-md-3">
                                <label className={`${fulleventStyle.fulleventLabel} form-label`}> Location </label>
                                <input type="text" className={`${fulleventStyle.fulleventInput} form-control`} value={eventData.length > 0 ? eventData[0].event_location : "Loading..."}  placeholder='Library' />
                            </div> 
                            <div className="col-md-3">
                                <label className={`${fulleventStyle.fulleventLabel} form-label`}> Time </label>
                                <input type="text" className={`${fulleventStyle.fulleventInput} form-control`}
                                    value={eventData.length > 0
                                        ? `${formatToAMPM(eventData[0].event_start_time)} - ${formatToAMPM(eventData[0].event_end_time)}`
                                        : ''
                                    } />
                            </div>       
                        </div>
                        <div className='row'>
                            <div className="col-md-11">
                                <label className={`${fulleventStyle.fulleventLabel} form-label`}> Message for Parents </label>
                                <textarea className={`${fulleventStyle.fulleventInput} form-control`} rows="4" value={eventData.length > 0 ? eventData[0].event_notes : "Loading..."} ></textarea>
                            </div>                                    
                        </div> */}
                                </div>

                                <div className={fulleventStyle.fulleventAccordion}>
                                    <div className="accordion mb-3">
                                        {eventData && Array.isArray(eventData) && eventData.length > 0 ? (eventData.map((event, index) => (event.books.map((book, bookIndex) => (

                                            <div>
                                                <div className={`${fulleventStyle.fulleventMainacordionitem} accordion-item`} style={{ borderRadius: '20px' }} key={bookIndex} >
                                                    <h2 className="accordion-header d-flex align-items-center justify-content-between">
                                                        <button className={`${fulleventStyle.fulleventacordionbuttonItem} accordion-button ${openIndex === bookIndex ? `${fulleventStyle.fulleventbgColor}` : 'collapsed'}`} type="button" onClick={() => handleToggle(bookIndex)} aria-expanded={openIndex === bookIndex ? 'true' : 'false'} aria-controls="collapseOne">
                                                            <span className={`me-5 ${fulleventStyle.minWidth100}`}> Name <small className='ps-2'> {book.authorName} </small> </span>
                                                            <span className='me-auto'> Title <small className='ps-2'> Author & Illustrator </small> </span>

                                                        </button>
                                                        {
                                                            event.status.toLowerCase() !== "waiting for approval" && (<a className="accordionDeletebtn btn btn-danger me-4" onClick={() => handleDeleteAuthor(bookIndex)}>
                                                                Delete
                                                            </a>)
                                                        }

                                                    </h2>
                                                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === bookIndex ? 'show' : ''}`}>
                                                        <div className="accordion-body pt-0">
                                                            <div className={`${fulleventStyle.fulleventinfoWrapper}`}>
                                                                <div className='d-flex align-items-start mb-4'>
                                                                    <div className='me-5'>
                                                                        <div className={`${fulleventStyle.fulleventacoorImagebox} mb-2`}>

                                                                            <img src={`https://www.authormeet.net/authormeetapi/images/author/${book.authorData && Object.values(book.authorData).length > 0
                                                                                ? Object.values(book.authorData)[0]
                                                                                : "default"
                                                                                }.jpg`} className='img-fluid w-100' />
                                                                        </div>
                                                                        <div className='d-flex justify-content-between align-items-center'>
                                                                            <a href='#' className='ps-2'>
                                                                                <IoLinkOutline className={fulleventStyle.fulleventlinkico} />
                                                                            </a>

                                                                            <Link
                                                                                to={`/CoordinatorAuthorProfilePage/${book.authorData && Object.values(book.authorData).length > 0
                                                                                    ? Object.values(book.authorData)[0]
                                                                                    : "default"
                                                                                    }`}
                                                                                className={fulleventStyle.fulleventviewlink}
                                                                            >
                                                                                View Author Page
                                                                            </Link>
                                                                        </div>
                                                                        <div>
                                                                            <Checkbox />
                                                                        </div>
                                                                    </div>
                                                                    <div className={fulleventStyle.fulleventboarddata}>
                                                                        <h5> Bio <Checkbox />
                                                                            <div className={fulleventStyle.tooltipcontainer} ref={boxRef}>
                                                                                <button className={fulleventStyle.infobtn} onClick={() => setOpen(!open)}>i</button>

                                                                                {open && (
                                                                                    <div className={fulleventStyle.tooltipbox}>
                                                                                        <h3>Activate or Deactivate Author Bio</h3>
                                                                                        <p>
                                                                                            Check the box if you’d like to include the author bio on the parent
                                                                                            page for the author event.
                                                                                        </p>
                                                                                    </div>
                                                                                )}
                                                                            </div> </h5>
                                                                        <p>
                                                                            {
                                                                                book.authorData && Object.values(book.authorData).length > 0
                                                                                    ? Object.values(book.authorData)[9]
                                                                                    : ""
                                                                            }
                                                                        </p>
                                                                        <h5> Authors Note to Families <Checkbox /> </h5>
                                                                        <p>
                                                                            {
                                                                                book.authorData && Object.values(book.authorData).length > 0
                                                                                    ? Object.values(book.authorData)[11]
                                                                                    : ""
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className={`${fulleventStyle.fulleventSliderhead} d-flex align-items-center flex-wrap`}>
                                                                    <h4> Book List: {book.authorName} </h4>
                                                                    <p className='ms-auto'> <b className='me-2'> Order by date: </b>{
                                                                        eventData[0]?.event_order_date
                                                                            ? formatDateMMDDYYYY(eventData[0].event_order_date)
                                                                            : "00/00/0000"
                                                                    }</p>
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-lg-12'>
                                                                        <div className={fulleventStyle.mainbookBox}>
                                                                            <ul className={`${fulleventStyle.products} ${fulleventStyle.columns5} p-0`}>
                                                                                {book.authorBookDataAdded.flatMap(a => a.books)
                                                                                    .slice(0, showAllBooks ? undefined : 5).map((aubooks, aubookIndex1) => (
                                                                                        <li key={aubookIndex1} className={fulleventStyle.product}>
                                                                                            <div className={fulleventStyle.fulleventproductblock}>
                                                                                                {/* <div className={fulleventStyle.fulleventproductimg}>
                                                                                            <img src={`https://www.authormeet.net/authormeetapi/images/ProductImages/${aubooks.isbn}.jpg`} width="600" height="840" />
                                                                                        </div> */}

                                                                                                <div className={fulleventStyle.fulleventproductimg} style={{ width: "120px", height: "160px", overflow: "hidden" }}>
                                                                                                    <img src={`https://www.authormeet.net/authormeetapi/images/ProductImages/${aubooks.isbn}.jpg`} style={{ width: "100%", height: "100%" }} />
                                                                                                </div>


                                                                                                <div className="mt-1">
                                                                                                    <h5 className={`text-start ${fulleventStyle.singLineTitle}`} title={aubooks.title}>{aubooks.title}</h5>
                                                                                                    <p className='text-start'>$ {aubooks.price}</p>
                                                                                                </div>
                                                                                                {isDraft && (
                                                                                                    <button
                                                                                                        className="btn btn-danger btn-sm mt-1"
                                                                                                        onClick={() => handleRemoveBook(bookIndex, aubookIndex1)}
                                                                                                    >
                                                                                                        Remove Book
                                                                                                    </button>
                                                                                                )}
                                                                                            </div>
                                                                                        </li>
                                                                                    ))}
                                                                            </ul>

                                                                            {/* SEE MORE / SEE LESS BUTTON */}
                                                                            {book.authorBookDataAdded.flatMap(a => a.books).length > 5 && (
                                                                                <div className="text-center">
                                                                                    <button
                                                                                        className="btn btn-primary mt-3"
                                                                                        onClick={() => setShowAllBooks(!showAllBooks)}
                                                                                    >
                                                                                        {showAllBooks ? "See Less" : "See More"}
                                                                                    </button>
                                                                                </div>
                                                                            )}



                                                                            {/* ADD NEW BOOK BUTTON */}
                                                                            {isDraft && (
                                                                                <div className="mt-3 d-flex align-items-center">
                                                                                    <input
                                                                                        type="text"
                                                                                        placeholder="Enter ISBN"
                                                                                        value={newBookIsbn[bookIndex] || ""}
                                                                                        onChange={(e) =>
                                                                                            setNewBookIsbn((prev) => ({ ...prev, [bookIndex]: e.target.value }))
                                                                                        }
                                                                                        className="form-control me-2"
                                                                                    />
                                                                                    <button
                                                                                        className="btn btn-success text-nowrap"
                                                                                        onClick={() => handleAddBook(bookIndex)}
                                                                                    >
                                                                                        Add Book
                                                                                    </button>
                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                            </div>
                                        ))
                                        ))
                                        ) :
                                            (
                                                <div className={`${fulleventStyle.alertBox} alert alert-danger d-flex align-items-center`} role="alert">
                                                    Data Loading
                                                </div>
                                            )}
                                    </div>

                                    {
                                        editableEvent?.status == "draft" && (<button className="addanotherauthorButton btn btn-success" onClick={addAccordion}>
                                            <FiPlusCircle className="addanotherauthorbtnIcon me-1" /> Add another author
                                        </button>)
                                    }


                                </div>
                            </div>
                            <div className="col-2">

                                {
                                    editableEvent?.status === "draft" ? (<div className={fulleventStyle.fulleventsaveBox}>
                                        <h4>Save your work:</h4>
                                        <p>After finishing and reviewing the event page, be sure to save your work. </p>
                                        <button className={`${editableEvent?.status === "draft" ? 'btn-primary' : 'btn-danger'} btn  w-100`} onClick={handleSaveEvent}>{editableEvent?.status === "draft" ? "Save and exit" : "Close"}</button>
                                    </div>) : (<button className={`${editableEvent?.status === "draft" ? 'btn-primary' : 'btn-danger'} btn  w-100`} onClick={handleSaveEvent}>{editableEvent?.status === "draft" ? "Save and exit" : "Close"}</button>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
